import axios from 'axios'
import router from '@/router'

const api = axios.create({
  baseURL: process.env.VUE_APP_URL_API_CLIENT,
  timeout: 30000 // 30 second timeout for file uploads
})

// Request interceptor
api.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token')
    
    if (token) {
      config.headers.Authorization = `Token ${token}`
    }
    
    // Check if the request contains FormData (file upload)
    if (config.data instanceof FormData) {
      // Remove Content-Type header to let the browser set it with boundary
      delete config.headers['Content-Type']
    } else {
      // For regular JSON requests
      config.headers['Content-Type'] = 'application/json'
    }
    
    return config
  },
  error => {
    console.error('Request error:', error)
    return Promise.reject(error)
  }
)

// Response interceptor
api.interceptors.response.use(
  response => response,
  error => {
    const status = error.response?.status
    const errorMessage = error.response?.data?.error || 'Une erreur est survenue'

    switch (status) {
      case 401:
        console.error('Authentication error:', errorMessage)
        localStorage.removeItem('token')
        router.push('/login')
        break
      case 403:
        console.error('Permission denied:', errorMessage)
        break
      case 413:
        console.error('File too large:', errorMessage)
        break
      default:
        console.error('API error:', errorMessage)
    }

    return Promise.reject(error)
  }
)

export default api